import { render, staticRenderFns } from "./EditarLaboratorio.vue?vue&type=template&id=a9c02284"
import script from "./EditarLaboratorio.vue?vue&type=script&lang=js"
export * from "./EditarLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports